module.exports = __webpack_public_path__ + "media/images/emblems/Agarn-db2f6098ce255e63f6a93d3fe93b1f38.png";